import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {ClientService} from '../services/client.service';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()

export class AuthHelper implements HttpInterceptor {

    modalInfo: object = {};

    constructor(private clientService: ClientService, private router: Router) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status) {
                    if (error.status === 400) {
                        if (error.error.message === 'Invalid or Expired Token') {
                            this.modalInfo = {
                                id: 'modal-error-interceptor',
                                message: 'Su sesión ha caducado. Por favor, introduzca sus datos de nuevo.'
                            };
                            this.clientService.modalInfo = this.modalInfo;
                            localStorage.removeItem('token');
                            this.router.navigateByUrl('');
                            setTimeout(() => {
                                document.getElementById('modal-error-interceptor').classList.remove('d-none');
                            }, 500);
                        }
                        if (error.error.message === 'No se encuentra el documento') {
                            setTimeout(() => {
                                document.getElementById('modal-error-dni').classList.remove('d-none');
                            }, 500);
                        }
                        return throwError(error);
                    } else if (error.status === 406) {
                        return throwError(error);
                    } else {
                        return throwError(error.error);
                    }
                } else {
                    return throwError(error);
                }
            })
        );
    }
}
